export function collectValidationMessages(errors) {
  if (!errors) {
    return [];
  }

  if (typeof errors.all === 'function') {
    return errors.all().filter(Boolean);
  }

  if (Array.isArray(errors.items)) {
    return errors.items.map((item) => item.msg).filter(Boolean);
  }

  return [];
}

export function buildValidationAnnouncement(
  errors,
  prefix = 'Please correct the following errors.'
) {
  const messages = collectValidationMessages(errors);
  if (!messages.length) {
    return '';
  }

  return `${prefix} ${messages.join('. ')}`;
}

export function announceValidationErrorsViaStatus(vm, statusKey, errors, options = {}) {
  const text = buildValidationAnnouncement(errors, options.prefix);
  if (!text || !vm) {
    return;
  }

  vm[statusKey] = '';
  vm.$nextTick(() => {
    vm[statusKey] = text;
  });
}

function isInvalidField(el) {
  if (!el) {
    return false;
  }

  return el.getAttribute('aria-invalid') === 'true' || el.classList.contains('is-danger');
}

export function focusFirstInvalidField(rootEl, fieldIds = []) {
  if (!rootEl || typeof rootEl.querySelector !== 'function') {
    return;
  }

  let field = null;
  for (let i = 0; i < fieldIds.length; i++) {
    const candidate = rootEl.querySelector('#' + fieldIds[i]);
    if (isInvalidField(candidate)) {
      field = candidate;
      break;
    }
  }

  if (!field) {
    field = rootEl.querySelector('[aria-invalid="true"], input.is-danger, select.is-danger, textarea.is-danger');
  }

  if (field && typeof field.focus === 'function') {
    field.focus();
  }
}



// WEBPACK FOOTER //
// ./src/utils/formValidationAnnounce.js